import { gql } from "@apollo/client";export default gql`query setAggregate($where: set_bool_exp) {
    setAggregate: set_aggregate(where: $where) {
        aggregate {
            count
        }
    }
}
`;
